import {
  BarChart3,
  BookOpen,
  Boxes,
  Calculator,
  FileText,
  Gift,
  Layers,
  LucideIcon,
  Package,
  Tag,
  TrendingUp
} from 'lucide-react';

import {
  NAV_PAGES,
  type NavFeatureKey,
  type NavGroup
} from '@/shared/routes/pageRegistry';
import type { BrandFeatureFlag } from '@/shared/types/brand';
import type { FeatureKey } from '@/shared/types/features';

export interface NavigationItem {
  title: string;
  path: string;
  icon: LucideIcon;
  /** Primary feature — analytics key + icon key. */
  featureKey: FeatureKey;
  /**
   * Any of these grants access to the page (OR-gated); defaults to
   * `[featureKey]`. See NavPage.accessFeatureKeys.
   */
  accessFeatureKeys?: readonly FeatureKey[];
  /** Per-brand flag that also gates the page. See NavPage.brandFlag. */
  brandFlag?: BrandFeatureFlag;
  /** Sidebar grouping (S3). Carried through from NAV_PAGES. */
  group: NavGroup;
}

// Titles/paths/ordering/gating live in pageRegistry to keep lucide-react out of the
// prerendered landing chunk. Keyed by NavFeatureKey so a NAV_PAGES entry without an
// icon fails type-check here.
const NAV_ICONS: Record<NavFeatureKey, LucideIcon> = {
  PROGRAMS: Layers,
  KITS_ORDERING: Package,
  ANALYTICS: BarChart3,
  BRAND_PERFORMANCE_THREDUP: TrendingUp,
  CASHOUT_TILE: Tag,
  ROI_CALCULATOR: Calculator,
  REPORTS: FileText,
  KNOWLEDGE_BASE: BookOpen,
  GIFT_CARDS: Gift,
  DROPSHIPPING: Boxes
};

export const NAVIGATION_ITEMS: NavigationItem[] = NAV_PAGES.map((page) => ({
  ...page,
  icon: NAV_ICONS[page.featureKey]
}));
